'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Condition = require('./Condition.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPERATORS = {
    'value': function value(params) {
        var operator = params.operator;
        return operator.value;
    },
    'min': function min(params) {
        var operator = params.operator;

        return _lodash2.default.min(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'max': function max(params) {
        var operator = params.operator;

        return _lodash2.default.max(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'multiply': function multiply(params) {
        var operator = params.operator;

        var numerators = 1;
        var denominators = 1;

        _lodash2.default.each(operator.numerators, function (_operator) {
            numerators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        _lodash2.default.each(operator.denominators, function (_operator) {
            denominators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        var result = numerators / denominators;

        return Math.sign(result) * Math.floor(Math.abs(result) + 0.5);
    },
    'count_items': function count_items(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        var total = 0;

        _lodash2.default.each(orderItems, function (orderItem) {
            if (isApplicableItem(orderItem.itemId, operator.items)) {
                total += orderItem.count || 1;
            }
        });

        _lodash2.default.each(orderCharges, function (orderCharge) {
            if (isApplicableItem(orderCharge.chargeId, operator.charges)) {
                total++;
            }
        });

        return total;
    },
    'sum': function sum(params) {
        var operator = params.operator;

        var result = 0;

        _lodash2.default.each(operator.operators, function (_operator) {
            result += calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        return result;
    },
    'sum_prices': function sum_prices(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        // Get all applicable items' price in a sorted list
        var applicableItems = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderItems, function (orderItem) {
            if (!isApplicableItem(orderItem.itemId, operator.items)) {
                return null;
            }
            return _lodash2.default.map(_lodash2.default.range(orderItem.count || 1), function () {
                return _OrderItem2.default.getTotalPrice({ orderItem: orderItem }) / (orderItem.count || 1);
            });
        })));

        // Get all applicable items' price in a sorted list
        var applicableCharges = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderCharges, function (orderCharge) {
            if (!isApplicableItem(orderCharge.chargeId, operator.charges)) {
                return null;
            }
            return orderCharge.amount;
        })));

        var applicable = (0, _lodash2.default)(applicableItems).concat(applicableCharges).value().sort(function (x, y) {
            return x - y;
        });

        // Re-calculate Y
        var max = Math.min(operator.maxCount || Number.MAX_VALUE, applicable.length);

        // Ensure there's the right amount of items
        if (max < 0) return 0;

        return _lodash2.default.reduce(applicable.splice(0, max), function (memo, num) {
            return memo + num;
        }, 0);
    }
};

function calculateOperator(params) {
    var operator = params.operator;

    var func = OPERATORS[operator.type] || function () {
        return 0;
    };
    var ret = func(params);

    return ret;
}

function isApplicableItem(itemId, idsFilter) {
    if (!idsFilter) return false;

    if ((idsFilter.type || 'include') === 'include') {
        return _lodash2.default.includes(idsFilter.ids, itemId);
    } else {
        return !_lodash2.default.includes(idsFilter.ids, itemId);
    }
}

exports.default = {

    isApplicable: function isApplicable(params) {
        var charge = params.charge;
        var deliveryTime = params.deliveryTime;
        var deliveryType = params.deliveryType || '';
        var orderItems = params.orderItems || [];
        var source = params.source;
        var platform = params.platform;
        var couponHashCode = params.couponHashCode;

        if (charge.state === 'closed') return false;

        return (0, _Condition.checkCondition)({ condition: charge.condition, deliveryTime: deliveryTime, deliveryType: deliveryType,
            orderItems: orderItems, source: source, platform: platform, couponHashCode: couponHashCode });
    },

    isDisplayable: function isDisplayable(params) {
        var charge = params.charge;
        var deliveryTime = params.deliveryTime;
        var deliveryType = params.deliveryType || '';
        var orderItems = params.orderItems || [];
        var source = params.source;
        var platform = params.platform;
        var couponHashCode = params.couponHashCode;

        if (charge.state === 'closed') return false;

        return (0, _Condition.checkCondition)({ condition: charge.displayCondition, deliveryTime: deliveryTime, deliveryType: deliveryType,
            orderItems: orderItems, source: source, platform: platform, couponHashCode: couponHashCode });
    },

    isRestrictedByOrderItems: function isRestrictedByOrderItems(params) {
        var amount = this.calculateAmount(params);
        var extractValues = function extractValues(o, path) {
            if (!o || (typeof o === 'undefined' ? 'undefined' : _typeof(o)) !== 'object') return [];

            var values = _lodash2.default.get(o, path) || [];
            var nextValues = Object.keys(o).map(function (key) {
                return extractValues(o[key], path);
            });
            return values.concat(_lodash2.default.flatten(nextValues));
        };

        if (!amount) {
            var itemIds = extractValues(params.charge.operator, 'items.ids');
            var orderItems = itemIds.map(function (id) {
                return { itemId: id, price: 10000 };
            });
            var otherAmount = this.calculateAmount(_extends({}, params, { orderItems: orderItems }));
            return !!otherAmount;
        }

        return false;
    },

    calculateAmount: function calculateAmount(params) {
        var charge = params.charge;
        var tip = params.tip || 0;
        var orderItems = params.orderItems || [];
        var orderCharges = params.orderCharges || [];
        var extraCost = params.extraCost;

        if (!this.isApplicable(params)) return 0;

        if (charge.type == 'tip') return tip;

        return calculateOperator({ operator: charge.operator, orderItems: orderItems, orderCharges: orderCharges,
            extraCost: extraCost });
    }
};